//@ts-nocheck
import { useState } from 'react';
import type { NextPage } from 'next';
import Link from 'next/link';
import Image from 'next/image';

type ReadProps = {
  mT?: string;
};

export const ChanelSS23 = ({ mT }: ReadProps) => {
  return (
    <>
      {/* <span style={{ fontSize: '13px', marginTop: mT }}>Haute Couture</span> */}
      <h3 style={{ marginTop: mT }}>CHANEL</h3>
      <span style={{ fontSize: '13px' }}>Spring / Summer 23</span>
      <div>
        <video
          controls={true}
          controlsList="nodownload"
          playsInline
          muted
          autoPlay
          loop
          style={{ width: '100%', maxWidth: '100%' }}
        >
          <source
            src={
              '/media/chanel_SS_23.mp4'
            }
            type="video/mp4"
          />
        </video>
      </div>
      <h4>A WORLD OF ENCHANTMENT.</h4>
      <p className="topPargraph" style={{margin: 0}}>
        <b>A Song of Scales and Feathers: A Tribute to Mythical Beasts</b>
        <br />
        Across cultures and through time, whispers of fantastical creatures have
        echoed in our stories. These mythical beasts, far from mere figments of
        imagination, embody the wonders and terrors of the unknown. Today, we
        raise a metaphorical flag in their honor.
        <br />
        <br />
        <b>Guardians of the Wild:</b> From the griffin, a majestic union of lion
        and eagle, to the wise centaurs, half-man, half-horse, these creatures
        represent the untamed spirit of nature. They remind us of the power and
        mystery that lies within the wilderness.
        <br />
        <br />
        <b>Embodiments of Power:</b> Dragons, with their fiery breath and
        immense size, symbolize raw, untamed power. The phoenix, rising from the
        ashes, speaks of resilience and the ever-present potential for renewal.
        <br />
        <br />
        <b>Whispers of the Unknown:</b> Creatures like the Loch Ness monster and
        the elusive yeti pique our curiosity about the hidden depths of our
        world. They remind us that the boundaries of knowledge are
        ever-shifting, and the veil between reality and legend remains thin.
        <br />
        <br />
        <b>Artistic Inspiration:</b> From the breathtaking sculptures of
        griffins guarding ancient temples to the fantastical tales spun by bards
        and novelists, these creatures have served as endless muses for artistic
        expression.
        <br />
        <br />
        <b>Moral Lessons:</b> Many myths weave cautionary tales around these
        beasts. Sirens, with their enchanting song, warn of succumbing to
        temptation, while the labyrinth guarded by the Minotaur reminds us of
        the perils of unchecked pride.
        <br />
        <br />
        <b>
          Let the fire of the dragon's breath, the wisdom of the centaur, and
          the curiosity sparked by the unknown continue to inspire us. As long
          as we hold onto these stories, the legacy of mythical beasts will
          forever echo in our hearts.
        </b>
        <br />
        In the vast tapestry of human imagination, there exists a realm where
        reality intertwines with fantasy, and ordinary creatures transform into
        majestic beings of legend. These mythical beasts, born from the whispers
        of ancient tales and the depths of our dreams, have captured the
        fascination of cultures worldwide for millennia. From the fiery depths
        of volcanoes to the serene heights of celestial heavens, they roam the
        realms of our minds, embodying the essence of magic, power, and wonder.
        <br />
        <br />
        <b>The Majestic Dragon</b>
        <br />
        At the pinnacle of mythical creatures stands the dragon, an emblem of
        strength and wisdom across cultures. In Chinese mythology, the dragon
        symbolizes potent energy, bringing rain for crops and guarding precious
        treasures. Western lore portrays dragons as fierce, fire-breathing
        creatures hoarding gold in cavernous lairs. From the benevolent Smaug of
        Tolkien's Middle-earth to the elegant Lung of Chinese art, dragons
        embody the duality of chaos and order, fear and awe.
        <br />
        <br />
        <b>The Enigmatic Unicorn</b>
        <br />
        In contrast to the dragon's might, the unicorn dances upon the fringes
        of imagination, a creature of purity and grace. Its single spiraling
        horn, said to possess healing properties, symbolizes untamed beauty and
        elusive magic. Throughout history, the unicorn has been a symbol of
        rarity and purity, appearing in medieval tapestries and Renaissance art
        as a creature of both fascination and divine connection.
        <br />
        <br />
        <b>The Elusive Griffin</b>
        <br />
        With the body of a lion and the head and wings of an eagle, the griffin
        embodies the union of earth and sky, strength and swiftness. Originating
        in ancient Greek and Persian mythology, this creature guards treasures
        and sacred places with unmatched ferocity. A symbol of divine power and
        protection, the griffin's image can be found in architecture, heraldry,
        and literature, a testament to its enduring allure.
        <br />
        <br />
        <b>The Mysterious Phoenix</b>
        <br />
        Rising from its own ashes, the phoenix is a symbol of rebirth and
        immortality. Across cultures, from ancient Egypt to modern fantasy, this
        fiery bird represents the cyclical nature of life, death, and renewal.
        With vibrant plumage and a haunting song, the phoenix captivates hearts
        as it eternally circles the realms of existence, its presence a reminder
        of the enduring power of hope and regeneration.
        <br />
        <br />
        <b>The Noble Pegasus</b>
        <br />
        With wings of purest white and a spirit as free as the wind, the pegasus
        embodies the dream of flight. In Greek mythology, this divine horse
        carries thunderbolts for Zeus, while in other tales, it serves as a
        symbol of poetic inspiration and the connection between earthly and
        divine realms. Artists and poets have long been enamored with the
        pegasus, capturing its elegance and grace in countless works of art.
        <br />
        <br />
        <b>A Timeless Fascination</b>
        <br />
        As we pay tribute to these mythical beasts, we recognize that their
        allure goes beyond mere fantasy. They represent our deepest desires,
        fears, and aspirations, mirroring the complexities of the human
        experience. Through their stories, we explore the depths of our
        imagination and ponder the mysteries of existence. Whether as guardians
        of ancient realms or companions on epic quests, mythical beasts continue
        to captivate our hearts and inspire us to dream beyond the boundaries of
        the known world.
        <br />
        <br />
        So let us raise our voices in homage to these legendary creatures, whose
        tales have woven themselves into the very fabric of human history. May
        their spirits roam forever in the realms of our imagination, reminding
        us of the magic that dwells within us all.
      </p>
    </>
  );
};
